import getDependencies from '../getDependencies';

export function removeData(data, type, state) {
  if (data.isTemporary) {
    return;
  }

  const { feedsToUpdate, dataFeeds } = getDependencies(data, type);

  feedsToUpdate.forEach(id => {
    if (!state[id]) {
      return;
    }

    const newItems = state[id].items.map(items => items.filter(itemId => itemId !== data.id));
    state[id] = { ...state[id], items: newItems };

    if (state[id].items.reduce((prev, next) => prev.length + next.length) === 0) {
      dataFeeds.push(id);
    }
  });

  dataFeeds.forEach(id => delete state[id]);
}

export default (dataToDelete, oldState) => {
  if (!dataToDelete) {
    return oldState;
  }

  const state = { ...oldState };
  Object.entries(dataToDelete)
    .forEach(([type, datas]) =>
      datas.forEach(data => removeData(data, type, state))
    );

  return state;
};



// WEBPACK FOOTER //
// ./~/virgo/src/reducers/feeds/paginated/remove.js